"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeError = exports.serializeError = void 0;

/**
 * Converts an error object into a plain object.
 * @param {Error} Error object.
 * @returns {Object}
 */
const serializeError = (_ref) => {
  let name = _ref.name,
      message = _ref.message,
      stack = _ref.stack;
  return {
    name,
    message,
    stack
  };
};
/**
 * Converts a plain object into an error object.
 * @param {Object} Object with error properties.
 * @returns {Error}
 */


exports.serializeError = serializeError;

const deserializeError = obj => {
  const deserializedError = new Error();
  Object.keys(obj).forEach(key => deserializedError[key] = obj[key]);
  return deserializedError;
};

exports.deserializeError = deserializeError;